import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Table } from "@/features/Table";
import { getDownloadCenterColumns, TDowloadCenter } from "./columns";
import {
  type FilterDowloadCenterSchemaType,
  FilterDowloadCenter,
} from "./filter";
import { useLocation } from "react-router";

const client = "s1-quantilia";
const table_name = "s1_download_center";

export const S1DowloadCenterTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;
  const { t, i18n } = useTranslation();
  const columns = useMemo(
    () => getDownloadCenterColumns(t),
    [t, i18n.language],
  );

  return (
    <Table<TDowloadCenter, FilterDowloadCenterSchemaType>
      label="S1 Metadata"
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterDowloadCenter />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
